import { styled } from '@material-ui/core';

export const CoinIcon = styled('img')({
  width: '40px',
  height: '40px',
  marginRight: '16px',
});
